import { createSlice } from '@reduxjs/toolkit';
import InviteBuyerRepository from 'repositories/realEstateAgent/InviteBuyerRepository';
import { createRestSlice } from 'utils/RestSlice';

const restSlice = createRestSlice({
  resource: 'buyerInvite',
  repository: InviteBuyerRepository,
  slices: ['createBuyerInvite'],
});

const initialState = {
  ...restSlice.initialState,
};

const realEstateAgentInviteBuyerSlice = createSlice({
  name: 'realEstateAgentInviteBuyerSlice',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default realEstateAgentInviteBuyerSlice;
export const realEstateAgentInviteBuyerReducer = realEstateAgentInviteBuyerSlice.reducer;
export const realEstateAgentInviteBuyerHooks = restSlice.hooks(
  realEstateAgentInviteBuyerSlice,
  'realEstateAgentInviteBuyerReducer',
);



// WEBPACK FOOTER //
// ./src/reducers/slices/realEstateAgent/inviteBuyerSlice.js